import { TEMP_OPTIONS, CURRENCY_OPTIONS, CURRENCY_NULL, RT_KWC_UNITS, ENERGY_OPTIONS } from "@/utils/options"
import { convertTempStore, saveCurrentProject, fetchProjectDetails } from "./actions"
export default {
  namespaced: true,
  state: () => ({
    currentProject: null,
    currentVrfSystem: null,
    currentVrfSystemList: [],

    estimated: false,
    eCatModelLib: null,
    pre: {
      plantCfg: {},
      weatherProfile: {},
      equipmentCfg: {},
      observation: {},
      equipmentList: {},
      profiles: [],
      profileCfg: {}
    }
  }),
  getters: {
    currentProject: state => state.currentProject,
    currentVrfSystem: state => state.currentVrfSystem,
    currentVrfSystemList: state => state.currentVrfSystemList,

    eCatModelLib: state => state.eCatModelLib,
    projectCfg: state => state.currentProject.projectCfg || {},

    plantCfg: state => state.currentProject.pre.plantCfg || {},
    spaceApplication: state => state.currentProject.pre.plantCfg?.spaceApplication || [0],
    tempUnit: state => TEMP_OPTIONS.find(x => x.value == state.currentProject.pre.plantCfg.tempUnit) || TEMP_OPTIONS[0],
    currency: state => CURRENCY_OPTIONS.find(x => x.value == state.currentProject.pre.plantCfg.currency) || CURRENCY_NULL,

    weatherProfile: state => state.currentProject.pre.weatherProfile || {},

    equipmentCfg: state => state.currentProject.pre.equipmentCfg || {},
    capacityUnit: state => RT_KWC_UNITS.find(x => x.value == state.currentProject.pre.equipmentCfg.chillerCfg?.capacityUnit) || RT_KWC_UNITS[0],

    boilerCfg: state => state.currentProject.pre.equipmentCfg.boilerCfg || {},
    chillerCfgType: state => state.currentProject.pre.equipmentCfg?.chillerCfg?.type || 0,
    energyType: state => ENERGY_OPTIONS.find(x => x.value === state.currentProject.pre.equipmentCfg.boilerCfg.energyType) || ENERGY_OPTIONS[0],

    observation: state => state.currentProject.pre.observation || {},

    profiles: state => state.currentProject.pre.profiles || [],
    profileCfg: state => state.currentProject.pre.profileCfg || {},

    equipmentList: state => state.currentProject.pre.equipmentList || {},
    chillerList: state => state.currentProject.pre.equipmentList?.chiller || []
  },
  mutations: {
    STORE_CURRENT_PROJECT(state, data) {
      state.currentProject = { ...state.currentProject, ...data }
    },
    STORE_CURRENT_VRFSYSTEM(state, data) {
      state.currentVrfSystem = data
    },
    STORE_VRFSYSTEM_LIST(state, data) {
      state.currentVrfSystemList = data
    },

    STORE_ESTIMATE_STATE(state, data = true) {
      state.estimated = data
    },
    STORE_E_CAT_LIB(state, datas) {
      state.eCatModelLib = [...datas]
    },

    CLEAR_STORE_PROJECT(state) {
      state.currentProject = null
    },

    STORE_PROJ_PRE(state, { path, value }) {
      const paths = path.split(".")
      const lastKey = paths.pop()
      const target = paths.reduce((obj, key) => obj[key], state.currentProject.pre)
      target[lastKey] = typeof value === "object" ? { ...target[lastKey], ...value } : value
    },

    STORE_PROJ_PRE(state, payload) {
      state.currentProject.pre = state.currentProject.pre || {}
      for (const [path, value] of Object.entries(payload)) {
        const paths = path.split(".")
        const lastKey = paths.pop()

        const target = paths.reduce((obj, key) => {
          if (!obj[key]) obj[key] = {}
          return obj[key]
        }, state.currentProject.pre)

        if (typeof value === "object" && !Array.isArray(value)) {
          target[lastKey] = { ...target[lastKey], ...value }
        } else {
          target[lastKey] = value
        }
      }
    },

    STORE_OBSERVATIONS(state, data) {
      state.currentProject.pre.observation = { ...data }
    },
    STORE_OBSERVATION(state, data) {
      state.currentProject.pre.observation[data.type] = { ...data }
    }
  },
  actions: {
    convertTempStore,
    saveCurrentProject,
    fetchProjectDetails,

    storeProject({ commit }, data) {
      commit("STORE_CURRENT_PROJECT", data)
    },
    storeVrfSystem({ commit }, data) {
      commit("STORE_CURRENT_VRFSYSTEM", data)
    },
    storeVrfSystemList({ commit }, data) {
      commit("STORE_VRFSYSTEM_LIST", data)
    },

    storeEstimateState({ commit }, data) {
      commit("STORE_ESTIMATE_STATE", data)
    },
    storeECatModelLib({ commit }, datas) {
      commit("STORE_E_CAT_LIB", datas)
    },

    clearProjectStore({ commit }) {
      commit("CLEAR_STORE_PROJECT")
    },

    storeProjectPre({ commit }, { path, value }) {
      commit("STORE_PROJ_PRE", { path, value })
    },

    storeProjectPre({ commit }, payload) {
      commit("STORE_PROJ_PRE", payload)
    },

    storeObservations({ commit }, [data, type]) {
      if (!type) commit("STORE_OBSERVATIONS", data)
      else commit("STORE_OBSERVATION", data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/projectPre/index.js